import { createFileRoute, lazyRouteComponent, notFound } from '@tanstack/react-router';
import { checkFeatureGateMfaPasskey } from '@/helpers/statsig/featureGate';
import { ensureStatsigUserFeatureGateReady } from '@/helpers/statsig/featureGate/ensureStatsigUserFeatureGateReady';

export const Route = createFileRoute('/_authenticated/_dashboard/security/passkeys')({
  beforeLoad: async ({ context }) => {
    await ensureStatsigUserFeatureGateReady(context);

    if (!checkFeatureGateMfaPasskey(context.statsigClient)) {
      throw notFound();
    }
  },
  staticData: {
    domain: 'iam',
  },
  component: lazyRouteComponent(() => import('./passkeys.component'), 'SecurityPasskeysComponent'),
});
